import { ref, computed, readonly } from "vue";
import { getPsInFoodProduct } from "@/core/api/graphql/psInFood";
import { Logger } from "@/core/utilities";
import type { ProductSearchResultType } from "@/core/api/graphql/types";
import type { Ref } from "vue";

enum PsInFoodAllergenLabel {
  Contains = "+",
  DoesNotContain = "-",
  MayContain = "+/-",
  NotSpecified = "0",
}

export function usePsInFoodProduct() {
  const loading: Ref<boolean> = ref(true);
  const psInFoodProduct: Ref<ProductSearchResultType | null> = ref(null);

  async function fetchPsInFoodProduct(ean: string, take = 1) {
    loading.value = true;
    try {
      psInFoodProduct.value = await getPsInFoodProduct(ean, take);
    } catch (e) {
      Logger.error("usePsInFoodProduct.loadProduct", e);
      throw e;
    } finally {
      loading.value = false;
    }
  }

  const ContainsClass = "contains";
  const NotContainsClass = "not-contains";

  function getPsInFoodAllergen(unit: number | undefined) {
    switch (unit) {
      case 1:
        return {
          label: PsInFoodAllergenLabel.Contains,
          class: ContainsClass,
        };
      case 2:
        return {
          label: PsInFoodAllergenLabel.DoesNotContain,
          class: NotContainsClass,
        };
      case 3:
        return {
          label: PsInFoodAllergenLabel.MayContain,
          class: ContainsClass,
        };
      default:
        return {
          label: PsInFoodAllergenLabel.NotSpecified,
          class: NotContainsClass,
        };
    }
  }

  return {
    fetchPsInFoodProduct,
    getPsInFoodAllergen,
    loading: readonly(loading),
    containsClass: ContainsClass,
    notContainsClass: NotContainsClass,
    psInFoodAllergenLabel: readonly(PsInFoodAllergenLabel),
    psInFoodProduct: computed(() => psInFoodProduct.value),
  };
}
